export const PAID = 'PAID';
export const NOT_PAID = 'NOT_PAID';
export const PARTIALLY_PAID = 'PARTIALLY_PAID';
